module.exports = __webpack_public_path__ + "img/nonperson.324aac15.png";